import { StringKeys } from '@/resources/strings/StringKeys';
import { t } from 'i18next';

/**
 *
 * @param {number} timestamp timestamp in milliseconds
 * @returns a human-readable string representing the time elapsed since the timestamp.
 * For example, "Just now", "1 minute ago", "5 minutes ago", "
 */
export const formatTimeAgo = (timestamp) => {
  const now = Date.now();
  const diff = now - timestamp;
  const minutes = Math.floor(diff / 60000);

  if (minutes < 1) return t(StringKeys.JUST_NOW);
  if (minutes === 1) return t(StringKeys.ONE_MINUTE_AGO);
  if (minutes < 60) return `${minutes} ${t(StringKeys.MINUTES_AGO)}`;

  const hours = Math.floor(minutes / 60);
  if (hours === 1) return t(StringKeys.ONE_HOUR_AGO);
  if (hours < 24) return `${hours} ${t(StringKeys.HOURS_AGO)}`;

  const days = Math.floor(hours / 24);
  if (days === 1) return t(StringKeys.ONE_DAY_AGO);
  return `${days} ${t(StringKeys.DAYS_AGO)}`;
};

/**
 *
 * @param {number} timestamp timestamp in milliseconds
 * Formats a timestamp to a human-readable hour format (HH:MM).
 * @returns
 */
export const formatTimeHour = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};
